module.exports = __webpack_public_path__ + "img/venus4.b3627af5.png";